import React, { useState, useEffect, Component, useMemo } from 'react'
import SecureShow from '../../component/SecureShow'
import "./style.css";
import { InputAdornment, TextField, Grid, Tooltip, Popover, Typography, Autocomplete, Button, IconButton, Menu, MenuItem } from '@mui/material';
import { IoIosSearch } from "react-icons/io";
import { IoCheckmarkCircle } from "react-icons/io5";
import { MdBlock } from "react-icons/md";
import { RiProhibited2Line } from "react-icons/ri";
import { FaInfoCircle, FaSquareFull } from "react-icons/fa";
import { FaHashtag } from "react-icons/fa";
import { DatePicker, TimePicker, Button as ButtonMd } from 'react-md';
import CategoryModal from './Modal/CategoryModal';
import AssignmentDetailModal from './Modal/AssignmentDetailModal';
import ApiRequestService from '../../component/ApiRequestService';
import NewAssignmentModal from './Modal/NewAssignmentModal';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import moment from 'moment';
import Toggle from 'react-toggle';
import { FiEdit, FiFile } from "react-icons/fi";
import { MdOutlineContentCut, MdOutlineContentCopy, MdOutlineContentPaste } from "react-icons/md";
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import { confirmAlert } from 'react-confirm-alert';
import { BsInfoCircleFill } from 'react-icons/bs';
import { FaExclamation } from "react-icons/fa6";
import { NOT_REQUIRED } from './Constants';
import CopyAllQuizDialog from '../../component/CopyAllQuizDialog';
import 'react-confirm-alert/src/react-confirm-alert.css'

const DEFAULT_ASSIGNMENT_COUNT = 14;
const DEFAULT_MASTERY_COUNT = 3;

const SCROLL_AMOUNT = 500;

const test = [
    {
        "category_name": "Alg. operations: Division of Fractions",
        "category_label": "",
        "category_id": 16,
        "topic_id": 2,
        "subject_id": 4,
        "difficulty_level": 0.89,
        "avg_time": 4,
        "evaluate_category": 0,
        "previous_subject_id": 0,
        "previous_topic_id": 0,
        "previous_category_id": 0,
        "archive_id": 0,
        "archive_mode": false,
        "category_stats": {
            "first_attempt_accuracy": 0,
            "last_attempt_accuracy": 0,
            "first_attempt_time": 0,
            "last_attempt_time": 0,
            "first_attempt_accuracy_sd": 0,
            "last_attempt_accuracy_sd": 0,
            "first_attempt_time_sd": 0,
            "last_attempt_time_sd": 0,
            "category_name": "",
            "category_id": 0,
            "topic_id": 0,
            "subject_id": 0,
            "category_attempt": 0,
            "total_number_of_student_first_attempt": 0,
            "total_number_of_student_last_attempt": 0
        },
        "enable_sync": false,
        "new_category_id": 0,
        "university_id": 0,
        "move_category_mode": false,
        "subject_name": "",
        "topic_name": "",
        "sync_status": 0,
        "sync_validation": true,
        "is_copying": false,
        "accuracyGoal": 0,
        "timeGoal": 0,
        "currentAccuracyGoal": 0,
        "currentTimeGoal": 0,
        "previousAccuracyGoal": 0,
        "previousTimeGoal": 0,
        "non_graded": 0
    },
    {
        "category_name": "Alg. operations: Division of Fractions, Physics",
        "category_label": "Div. of Fractions Physics Context",
        "category_id": 23,
        "topic_id": 2,
        "subject_id": 4,
        "difficulty_level": 0.85,
        "avg_time": 7.5,
        "evaluate_category": 0,
        "previous_subject_id": 0,
        "previous_topic_id": 0,
        "previous_category_id": 0,
        "archive_id": 0,
        "archive_mode": false,
        "category_stats": {
            "first_attempt_accuracy": 0,
            "last_attempt_accuracy": 0,
            "first_attempt_time": 0,
            "last_attempt_time": 0,
            "first_attempt_accuracy_sd": 0,
            "last_attempt_accuracy_sd": 0,
            "first_attempt_time_sd": 0,
            "last_attempt_time_sd": 0,
            "category_name": "",
            "category_id": 0,
            "topic_id": 0,
            "subject_id": 0,
            "category_attempt": 0,
            "total_number_of_student_first_attempt": 0,
            "total_number_of_student_last_attempt": 0
        },
        "enable_sync": false,
        "new_category_id": 0,
        "university_id": 0,
        "move_category_mode": false,
        "subject_name": "",
        "topic_name": "",
        "sync_status": 0,
        "sync_validation": true,
        "is_copying": false,
        "accuracyGoal": 0,
        "timeGoal": 0,
        "currentAccuracyGoal": 0,
        "currentTimeGoal": 0,
        "previousAccuracyGoal": 0,
        "previousTimeGoal": 0,
        "non_graded": 0
    }
]

const AssignmentMatrix = (props) => {

    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [showAssignmentDetailModal, setShowAssignmentDetailModal] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [columnOrder, setColumnOrder] = useState([...Array(DEFAULT_ASSIGNMENT_COUNT).keys()]);
    const [draggedColIndex, setDraggedColIndex] = useState(null);

    const [courses, setCourses] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [subjects, setSubjects] = useState(null);
    const [topics, setTopics] = useState(null);
    const [categories, setCategories] = useState(null);
    const [selectedCategories, setSelectedCategories] = useState(null);
    const [matrixCategories, setMatrixCategories] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [assignmentDetails, setAssignmentDetails] = useState([]);
    const [selectedAssignment, setSelectedAssignment] = useState(null);

    const [showNewAssignmentModal, setShowNewAssignmentModal] = useState(false);

    // This is when a category cell is clicked
    const [pickedAssignment, setPickedAssignment] = useState(null);
    const [pickedCategory, setPickedCategory] = useState(null);

    const [selectedSubject, setSelectedSubject] = useState(null);
    const [selectedTopic, setSelectedTopic] = useState(null);

    const [showArrow, setShowArrow] = useState(false);

    // Right click cell
    const [rightClickedCategory, setRightClickedCategory] = useState(null);
    const [sourceCategory, setSourceCategory] = useState(null);
    const [targetCategory, setTargetCategory] = useState(null);
    const [contextMenuAnchorEl, setContextMenuAnchorEl] = useState(null);
    const [action, setAction] = useState(null);

    // Import assign
    const [showImportModal, setShowImportModal] = useState(false);

    /*  useEffect(() => {
         const handleContextmenu = e => {
             e.preventDefault()
         }
         document.addEventListener('contextmenu', handleContextmenu)
         return function cleanup() {
             document.removeEventListener('contextmenu', handleContextmenu)
         }
     }, []) */

    const mappedCategories = useMemo(() => {
        return categories?.map(category => ({
            id: category.category_id,
            label: category.category_name,
            data: category,
        })) || [];
    }, [categories]);

    const checkScroll = () => {
        const table = document.querySelector(".assignment-table");
        if (table) {
            let val = table.scrollWidth > table.clientWidth
            setShowArrow(val);
        }
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setRightClickedCategory(null);
                setTargetCategory(null);
                setContextMenuAnchorEl(null);
                setSourceCategory(null);
                setAction(null);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        checkScroll();

        // Optional: also check on window resize
        window.addEventListener("resize", checkScroll);
        return () => window.removeEventListener("resize", checkScroll);
    }, [assignmentDetails]);

    useEffect(() => {
        getCourses();
        getSubjects();
    }, []);


    useEffect(() => {
        if (assignmentDetails && assignmentDetails.length) {
            // Get all the unique categories by the order of assignmentDetails
            let updatedMatrixCategories = [];
            // assignmentDetails.reverse();
            let catKeysSet = new Set();
            assignmentDetails.forEach(assignDetail => {
                if (assignDetail.quiz_subcat_info) {
                    assignDetail.quiz_subcat_info.forEach(detail => {
                        let catKey = `${detail.subject_id}_${detail.topic_id}_${detail.category_id}`;
                        if (!catKeysSet.has(catKey)) {
                            catKeysSet.add(catKey);
                            updatedMatrixCategories.push({
                                quiz_id: assignDetail.quiz_id,
                                quiz_type: assignDetail.quiz_type,
                                subject_name: detail.subject_name,
                                topic_name: detail.topic_name,
                                category_name: detail.category_Name,
                                key: catKey,
                                subject_id: detail.subject_id,
                                topic_id: detail.topic_id,
                                category_id: detail.category_id,
                                columnDataArr: [],
                            })
                        }
                    })
                }
            })

            updatedMatrixCategories.forEach((matrixCategory, index) => {
                let columnDataArr = [];
                assignmentDetails.forEach(assignDetail => {

                    let categoryMasteryCountJSON = {};
                    let categoryIsRequiredJSON = {};
                    let categoryPositionJSON = {};
                    let categoryNoOfQuestionsJSON = {};
                    try {
                        categoryMasteryCountJSON = JSON.parse(assignDetail.category_mastery_count || '{}');
                        categoryIsRequiredJSON = JSON.parse(assignDetail.category_is_required || '{}');
                        categoryPositionJSON = JSON.parse(assignDetail.category_position || '{}');
                        categoryNoOfQuestionsJSON = JSON.parse(assignDetail.category_number_of_questions || '{}');
                    } catch (e) {
                        console.error('JSON parse error in assignment:', assignDetail.id || assignDetail);
                    }
                    if (assignDetail.quiz_subcat_info) {
                        let category = assignDetail.quiz_subcat_info.find(cat => {
                            let key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
                            if (key === matrixCategory.key) {
                                return cat;
                            }
                            return null;
                        });
                        if (category) {
                            let mc = categoryMasteryCountJSON?.[matrixCategory.key] ?? null;
                            let noOfQuestions = categoryNoOfQuestionsJSON[matrixCategory.key] ?? null;
                            columnDataArr.push({
                                quiz_id: assignDetail.quiz_id,
                                quiz_type: assignDetail.quiz_type,
                                masteryCount: mc === 0 ? DEFAULT_MASTERY_COUNT : mc,
                                noOfQuestions: noOfQuestions && noOfQuestions !== 0 ? noOfQuestions : category.question_count,
                                atFirst: categoryPositionJSON?.[matrixCategory.key]?.category_at_begining === 1 ?? null,
                                atLast: categoryPositionJSON?.[matrixCategory.key]?.category_at_last === 1 ?? null,
                                freeChoice: categoryIsRequiredJSON?.[matrixCategory.key] === NOT_REQUIRED ?? null,
                                isTest: assignDetail.quiz_type === 1,
                            });
                        } else {
                            columnDataArr.push({
                                quiz_id: assignDetail.quiz_id,
                                quiz_type: assignDetail.quiz_type,
                            });
                        }
                    } else {
                        columnDataArr.push({
                            quiz_id: assignDetail.quiz_id,
                            quiz_type: assignDetail.quiz_type,
                        });
                    }
                })
                updatedMatrixCategories[index].columnDataArr = columnDataArr;
            })

            //console.debug("updatedMatrixCategories>>??", updatedMatrixCategories)
            updatedMatrixCategories.sort((catA, catB) => {
                return catA.category_name.localeCompare(catB.category_name);
            })
            setMatrixCategories(updatedMatrixCategories);

        }
    }, [assignmentDetails]);

    const onCompleteCopyQuiz = () => {
        setShowImportModal(false);
        getCourses();
    }

    const validateSubcategoryOrder = (subcategories) => {
        const seenCategoryKeys = [];
        const categoryKeyMap = subcategories.map(subcat =>
            `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`
        );

        for (let i = 0; i < categoryKeyMap.length; i++) {
            const key = categoryKeyMap[i];

            // If it's a new key, push it
            if (!seenCategoryKeys.includes(key)) {
                seenCategoryKeys.push(key);
            } else {
                // If key was seen earlier and is not the most recent, it's an interleaving
                if (seenCategoryKeys[seenCategoryKeys.length - 1] !== key) {
                    return false; // Invalid order
                }
            }
        }

        return true; // Valid order
    };

    const checkIfAssignmentIsValid = (assignmentDetail) => {
        console.debug("assignmentDetail>>??", assignmentDetail)
        if (assignmentDetail.quiz_name === "") {
            NotificationManager.error("Assignment name cannot be empty.", "Invalid Assignment")
            return false;
        }
        if (!assignmentDetail.start_date || !assignmentDetail.start_time) {
            NotificationManager.error("Please give assingnment a Start Date", "Invalid Assignment")
            return false;
        }
        if (!assignmentDetail.end_date || !assignmentDetail.end_time) {
            NotificationManager.error("Please give assingnment a End Date", "Invalid Assignment")
            return false;
        }

        if (assignmentDetail.sections_list === null || assignmentDetail.sections_list?.length === 0) {
            let msg = "Please select atleast one section"
            if (assignmentDetail.enable_subsection) {
                msg = "Please select atleast one section & subsection"
            }
            NotificationManager.error(msg, "Invalid Assignment");
            return false;
        }

        // check if atlease one subcategories is present
        if (assignmentDetail.quiz_subcat_info === null || assignmentDetail.quiz_subcat_info === undefined || assignmentDetail.quiz_subcat_info.length === 0) {
            NotificationManager.error("Atleast one subcategory should be added to the assignment", "Invalid Assignment");
            return false;
        }

        if (!validateSubcategoryOrder(assignmentDetail.quiz_subcat_info)) {
            NotificationManager.error("Please ensure that all the subcategories of a category are placed sequentially next to each other and are not spread out.", "Invalid Subcategory Order", 3000);
            return false;
        }

        if (assignmentDetail.quiz_subcat_info === null || (assignmentDetail.quiz_subcat_info && assignmentDetail.quiz_subcat_info.length === 0)) {
            NotificationManager.error("Assignment must have atleast 1 subcategory present.", "Invalid Assignment")
            return false;
        }


        return true;
    }

    const showAlert = async (title, msg, yesLabel, noLabel) => {
        return new Promise((resolve, reject) => {
            confirmAlert({
                title: title,
                // message: msg,
                childrenElement: () => <div className="custom-alert-content">{msg}</div>,
                confirmLabel: noLabel,
                cancelLabel: yesLabel,
                onConfirm: () => resolve(false),
                onCancel: () => resolve(true),
                overlayClassName: "overlay-custom-class-name",
            });
        });
    }

    const handleUpdateAssignmentDetails = (updatedAssignmentDetails) => {
        let sortedAssignments = getSortedAssignments(updatedAssignmentDetails);
        setAssignmentDetails([...sortedAssignments]);
        // NotificationManager.success("Assignments are arranged by")
    }

    const handleActionClick = async (currentAction) => {
        if (currentAction === 'paste') {

            let srcCategory = rightClickedCategory;

            let sourceAssignment = assignmentDetails[rightClickedCategory.columnDataIndex];
            let targetAssignment = assignmentDetails[targetCategory.columnDataIndex];
            console.debug("sourceAssignment and targetAssignment", sourceAssignment, targetAssignment);

            // Check if the source category has at_first/at_last turned ON and the target assignment has other category at first/at last on
            let targetHasAtFrist = false;
            let targetHasAtLast = false;
            console.debug("srcCategory>>??", srcCategory)
            if (srcCategory.atFirst || srcCategory.atLast) {
                // check if any target asign category except the target category has atfirst ON
                console.debug("targetAssignment>>??", targetAssignment)
                if (targetAssignment.category_position && targetAssignment.category_position != "{}") {
                    let categoryPositionMap = JSON.parse(targetAssignment.category_position);
                    Object.entries(categoryPositionMap).forEach(([key, val]) => {
                        console.debug("key, val >>", key, val);
                        if (key !== srcCategory.key) {
                            if (val.category_at_begining) {
                                targetHasAtFrist = true;
                            }
                            if (val.category_at_last) {
                                targetHasAtLast = true;
                            }
                        }
                    });
                }
            }

            // When pasting check if is targetAssignment has existing value, if so show an alert
            let present = targetAssignment?.quiz_details?.find(quiz_detail => {
                let key = `${quiz_detail.subject_id}_${quiz_detail.topic_id}_${quiz_detail.category_id}`
                return key === srcCategory.key;
            });

            let showAlertDialog = false;
            let alertTitle = "";
            let alertMessage = "";
            if (present && targetHasAtFrist) {
                showAlertDialog = true;
                alertTitle = "Replace Existing Data";
                alertMessage = <div>
                    <div>This cell already contains a category. Do you want to overwrite it with the copied one?</div>
                    <br />
                    <div>Note: Another category has "At First" turned ON, so "At First" will be turned OFF for the copied category.</div>
                </div>
            } else if (present && targetHasAtLast) {
                showAlertDialog = true;
                alertTitle = "Replace Existing Data";
                alertMessage = <div>
                    <div>This cell already contains a category. Do you want to overwrite it with the copied one?</div>
                    <br />
                    <div>Note: Another category has "At Last" turned ON, so "At Last" will be turned OFF for the copied category.</div>
                </div>
            } else if (present) {
                showAlertDialog = true;
                alertTitle = "Replace Existing Data";
                alertMessage = <div>
                    <div>This cell already contains a category. Do you want to overwrite it with the copied one?</div>
                </div>
            } else if (targetHasAtFrist) {
                showAlertDialog = true;
                alertTitle = "At First Conflict Detected";
                alertMessage = <div>
                    <div>Note: Another category has "At First" turned ON, so "At First" will be turned OFF for the copied category.</div>
                </div>
            } else if (targetHasAtLast) {
                showAlertDialog = true;
                alertTitle = "At Last Conflict Detected";
                alertMessage = <div>
                    <div>Note: Another category has "At Last" turned ON, so "At Last" will be turned OFF for the copied category.</div>
                </div>
            }

            if (showAlertDialog) {
                setTargetCategory(null);
                setContextMenuAnchorEl(null);
                const result = await showAlert(alertTitle, alertMessage, "Yes", "No");
                if (result === false) {
                    return;
                }
            }

            /* 
                Things needed to be updated when copying or pasting (only diff is when user cuts we have to remove it from source)
                1. category_mastery_count - DONE
                2. category_number_of_questions - DONE
                3. category_nocqc - DONE
                4. random_subcategory_order - DONE
                5. category_is_required - DONE
                6. category_position - DONE
            */

            if (action === 'copy') { // COPY and paste

                let quizDeleteArr = [
                    ...(sourceAssignment.quiz_details || []),
                    ...(targetAssignment.quiz_details || []),
                    ...(sourceAssignment.quiz_subcat_info || []),
                    ...(targetAssignment.quiz_subcat_info || []),
                ];

                // category_mastery_count
                let srcCategoryMasteryCountObj = {};
                if (sourceAssignment.category_mastery_count !== "" && sourceAssignment.category_mastery_count !== "{}") {
                    srcCategoryMasteryCountObj = JSON.parse(sourceAssignment.category_mastery_count);
                }
                let targetCategoryMasteryCountObj = {};
                if (targetAssignment.category_mastery_count !== "" && targetAssignment.category_mastery_count !== "{}") {
                    targetCategoryMasteryCountObj = JSON.parse(targetAssignment.category_mastery_count);
                }
                targetCategoryMasteryCountObj[srcCategory.key] = srcCategoryMasteryCountObj[srcCategory.key]
                targetAssignment["category_mastery_count"] = JSON.stringify(targetCategoryMasteryCountObj)

                // category_number_of_questions
                let srcCategoryNumberOfQuestionsObj = {};
                if (sourceAssignment.category_number_of_questions !== "" && sourceAssignment.category_number_of_questions !== "{}") {
                    srcCategoryNumberOfQuestionsObj = JSON.parse(sourceAssignment.category_number_of_questions);
                }
                let targetCategoryNumberOfQuestionsObj = {};
                if (targetAssignment.category_number_of_questions !== "" && targetAssignment.category_number_of_questions !== "{}") {
                    targetCategoryNumberOfQuestionsObj = JSON.parse(targetAssignment.category_number_of_questions);
                }
                targetCategoryNumberOfQuestionsObj[srcCategory.key] = srcCategoryNumberOfQuestionsObj[srcCategory.key]
                targetAssignment["category_number_of_questions"] = JSON.stringify(targetCategoryNumberOfQuestionsObj)

                // category_nocqc
                let srcCategoryNocqcObj = {};
                if (sourceAssignment.category_nocqc !== "" && sourceAssignment.category_nocqc !== "{}") {
                    srcCategoryNocqcObj = JSON.parse(sourceAssignment.category_nocqc);
                }
                let targetCategoryNocqcObj = {};
                if (targetAssignment.category_nocqc !== "" && targetAssignment.category_nocqc !== "{}") {
                    targetCategoryNocqcObj = JSON.parse(targetAssignment.category_nocqc);
                }
                targetCategoryNocqcObj[srcCategory.key] = srcCategoryNocqcObj[srcCategory.key]
                targetAssignment["category_nocqc"] = JSON.stringify(targetCategoryNocqcObj)

                // random_subcategory_order
                let srcRandomSubcategoryOrderObj = {};
                if (sourceAssignment.category_is_required !== "" && sourceAssignment.category_is_required !== "{}") {
                    srcRandomSubcategoryOrderObj = JSON.parse(sourceAssignment.category_is_required);
                }
                let targetRandomSubcategoryOrderObj = {};
                if (targetAssignment.random_subcategory_order !== "" && targetAssignment.random_subcategory_order !== "{}") {
                    targetRandomSubcategoryOrderObj = JSON.parse(targetAssignment.random_subcategory_order);
                }
                targetRandomSubcategoryOrderObj[srcCategory.key] = srcRandomSubcategoryOrderObj[srcCategory.key]
                targetAssignment["random_subcategory_order"] = JSON.stringify(targetRandomSubcategoryOrderObj)

                // category_is_required
                let srcCategoryIsRequiredObj = {};
                if (sourceAssignment.category_is_required !== "" && sourceAssignment.category_is_required !== "{}") {
                    srcCategoryIsRequiredObj = JSON.parse(sourceAssignment.category_is_required);
                }
                let targetCategoryIsRequiredObj = {};
                if (targetAssignment.category_is_required !== "" && targetAssignment.category_is_required !== "{}") {
                    targetCategoryIsRequiredObj = JSON.parse(targetAssignment.category_is_required);
                }
                targetCategoryIsRequiredObj[srcCategory.key] = srcCategoryIsRequiredObj[srcCategory.key]
                targetAssignment["category_is_required"] = JSON.stringify(targetCategoryIsRequiredObj)

                // category_position
                let srcCategoryPositionObj = {};
                if (sourceAssignment.category_position !== "" && sourceAssignment.category_position !== "{}") {
                    srcCategoryPositionObj = JSON.parse(sourceAssignment.category_position);
                }
                let targetCategoryPositionObj = {};
                if (targetAssignment.category_position !== "" && targetAssignment.category_position !== "{}") {
                    targetCategoryPositionObj = JSON.parse(targetAssignment.category_position);
                }
                targetCategoryPositionObj[srcCategory.key] = srcCategoryPositionObj[srcCategory.key];
                console.debug("targetCategoryPositionObj>>??", targetCategoryPositionObj[srcCategory.key], srcCategoryPositionObj[srcCategory.key])
                targetAssignment["category_position"] = JSON.stringify(targetCategoryPositionObj)

                // return;

                // quiz_subcat_info
                let categoryKey = srcCategory.key;
                let srcSubCatInfoArr = sourceAssignment.quiz_subcat_info.filter(subcatInfo => {
                    let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`
                    return key === categoryKey;
                });

                let currentMaxOrder = 0;
                if (Array.isArray(targetAssignment.quiz_subcat_info) && targetAssignment.quiz_subcat_info.length > 0) {
                    currentMaxOrder = Math.max(
                        ...targetAssignment.quiz_subcat_info.map(subcatInfo => subcatInfo.order || 0)
                    );
                } else {
                    targetAssignment.quiz_subcat_info = [];
                }

                targetAssignment.quiz_subcat_info = targetAssignment.quiz_subcat_info.filter(subcatInfo => {
                    let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`;
                    return key !== categoryKey;
                });
                let updatedSubCatInfoArr = srcSubCatInfoArr.map((info, index) => ({
                    ...info,
                    order: currentMaxOrder + index + 1
                }));
                targetAssignment.quiz_subcat_info.push(...updatedSubCatInfoArr);

                /* if (targetAssignment.quiz_subcat_info === null) {
                    targetAssignment.quiz_subcat_info = [...srcSubCatInfoArr];
                } else {
                    targetAssignment.quiz_subcat_info = targetAssignment.quiz_subcat_info.filter(subcatInfo => {
                        let key = `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}`;
                        return key !== categoryKey;
                    });
                    targetAssignment.quiz_subcat_info.push(...srcSubCatInfoArr);
                } */

                // quiz_details
                let srcQuizDetailsArr = sourceAssignment.quiz_details.filter(quizDetailInfo => {
                    let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`
                    return key === categoryKey;
                });
                currentMaxOrder = 0;
                if (Array.isArray(targetAssignment.quiz_details) && targetAssignment.quiz_details.length > 0) {
                    currentMaxOrder = Math.max(
                        ...targetAssignment.quiz_details.map(detail => detail.order || 0)
                    );
                } else {
                    targetAssignment.quiz_details = [];
                }
                targetAssignment.quiz_details = targetAssignment.quiz_details.filter(quizDetailInfo => {
                    let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`;
                    return key !== categoryKey;
                });
                let updatedQuizDetailsArr = srcQuizDetailsArr.map((info, index) => ({
                    ...info,
                    order: currentMaxOrder + index + 1
                }));
                targetAssignment.quiz_details.push(...updatedQuizDetailsArr);
                /* if (targetAssignment.quiz_details === null) {
                    targetAssignment.quiz_details = [...srcQuizDetailsArr];
                } else {
                    targetAssignment.quiz_details = targetAssignment.quiz_details.filter(quizDetailInfo => {
                        let key = `${quizDetailInfo.subject_id}_${quizDetailInfo.topic_id}_${quizDetailInfo.category_id}`;
                        return key !== categoryKey;
                    });
                    targetAssignment.quiz_details.push(...srcQuizDetailsArr);
                } */


                // Checking the subcategory ORDER and AT FIRST and AT LAST
                let updatedSubcategories = [];

                const atFirstKeys = new Set();
                const atLastKeys = new Set();

                Object.entries(JSON.parse(targetAssignment.category_position)).forEach(([key, value]) => {
                    if (value.category_at_begining) {
                        atFirstKeys.add(key);
                    } else if (value.category_at_last) {
                        atLastKeys.add(key);
                    }
                })

                let middleSubcats = [];
                let lastSubcats = [];
                let order = 1;

                targetAssignment.quiz_subcat_info.forEach(subcat => {
                    const key = `${subcat.subject_id}_${subcat.topic_id}_${subcat.category_id}`;

                    if (atFirstKeys.has(key)) {
                        updatedSubcategories.push({
                            ...subcat,
                            order: order++,
                        });
                    } else if (atLastKeys.has(key)) {
                        lastSubcats.push(subcat);
                    } else {
                        middleSubcats.push(subcat);
                    }
                });

                middleSubcats.forEach(subcat => {
                    updatedSubcategories.push({
                        ...subcat,
                        order: order++,
                    });
                });

                lastSubcats.forEach(subcat => {
                    updatedSubcategories.push({
                        ...subcat,
                        order: order++,
                    });
                });

                targetAssignment.quiz_details = [...updatedSubcategories];
                targetAssignment.quiz_subcat_info = [...updatedSubcategories];
                console.debug("updatedSubcategories>>??", updatedSubcategories);

                targetAssignment.quiz_delete_arr = [...quizDeleteArr];

                //console.debug("paste>>>>??", sourceAssignment, targetAssignment);
                // return;

                setLoading(true);
                handleSaveAssignment(targetAssignment).then(result => {
                    //console.debug("result>>??", result);
                    setLoading(false);
                    if (result.success) {
                        NotificationManager.success("Successfully copied the category");
                        let updatedAssignmentDetails = [...assignmentDetails];
                        updatedAssignmentDetails[targetCategory.columnDataIndex] = targetAssignment;
                        handleUpdateAssignmentDetails(updatedAssignmentDetails);
                    } else {
                        NotificationManager.error(result.error, 4000);
                    }
                });

            } else { // CUT and paste

                const fieldsToUpdate = [
                    'category_mastery_count',
                    'category_number_of_questions',
                    'category_nocqc',
                    'random_subcategory_order',
                    'category_is_required',
                    'category_position'
                ];

                let quizDeleteArr = [
                    ...(sourceAssignment.quiz_details || []),
                    ...(targetAssignment.quiz_details || []),
                    ...(sourceAssignment.quiz_subcat_info || []),
                    ...(targetAssignment.quiz_subcat_info || []),
                ];

                fieldsToUpdate.forEach(field => {
                    let srcObj = {};
                    if (sourceAssignment[field] && sourceAssignment[field] !== '{}') {
                        srcObj = JSON.parse(sourceAssignment[field]);
                    }

                    let targetObj = {};
                    if (targetAssignment[field] && targetAssignment[field] !== '{}') {
                        targetObj = JSON.parse(targetAssignment[field]);
                    }

                    targetObj[srcCategory.key] = srcObj[srcCategory.key];
                    delete srcObj[srcCategory.key]; // remove from source

                    sourceAssignment[field] = JSON.stringify(srcObj);
                    targetAssignment[field] = JSON.stringify(targetObj);
                });

                // quiz_subcat_info
                let categoryKey = srcCategory.key;

                const subcatFilterKey = subcatInfo =>
                    `${subcatInfo.subject_id}_${subcatInfo.topic_id}_${subcatInfo.category_id}` === categoryKey;

                // Move quiz_subcat_info
                let srcSubcatArr = sourceAssignment.quiz_subcat_info?.filter(subcatFilterKey) || [];

                sourceAssignment.quiz_subcat_info = sourceAssignment.quiz_subcat_info?.filter(sc => !subcatFilterKey(sc)) || [];
                targetAssignment.quiz_subcat_info = [
                    ...(targetAssignment.quiz_subcat_info?.filter(sc => !subcatFilterKey(sc)) || []),
                    ...srcSubcatArr
                ];

                // Move quiz_details
                let srcQuizDetailArr = sourceAssignment.quiz_details?.filter(subcatFilterKey) || [];

                sourceAssignment.quiz_details = sourceAssignment.quiz_details?.filter(qd => !subcatFilterKey(qd)) || [];
                targetAssignment.quiz_details = [
                    ...(targetAssignment.quiz_details?.filter(qd => !subcatFilterKey(qd)) || []),
                    ...srcQuizDetailArr
                ];

                sourceAssignment.quiz_delete_arr = quizDeleteArr;
                targetAssignment.quiz_delete_arr = quizDeleteArr;

                //console.debug("sourceAssignment and targetAssignment >>>???", sourceAssignment, targetAssignment)

                let updatedAssignmentDetails = [...assignmentDetails];
                updatedAssignmentDetails[rightClickedCategory.columnDataIndex] = sourceAssignment;
                updatedAssignmentDetails[targetCategory.columnDataIndex] = targetAssignment;
                handleUpdateAssignmentDetails(updatedAssignmentDetails);


                setLoading(true);
                Promise.all([
                    handleSaveAssignment(sourceAssignment),
                    handleSaveAssignment(targetAssignment)
                ]).then(([srcResult, tgtResult]) => {
                    setLoading(false);

                    if (srcResult.success && tgtResult.success) {
                        NotificationManager.success("Successfully moved the category");
                        let updatedAssignmentDetails = [...assignmentDetails];
                        updatedAssignmentDetails[rightClickedCategory.columnDataIndex] = sourceAssignment;
                        updatedAssignmentDetails[targetCategory.columnDataIndex] = targetAssignment;
                        handleUpdateAssignmentDetails(updatedAssignmentDetails);
                    } else {
                        NotificationManager.error("Failed to move category data", 4000);
                    }
                });
            }

            setRightClickedCategory(null);
            setSourceCategory(null);
            setTargetCategory(null);
            setContextMenuAnchorEl(null);
            setAction(null);
        } else {
            setAction(currentAction);
            setSourceCategory(rightClickedCategory);
            setContextMenuAnchorEl(null);
        }
    }

    const handleSaveAssignment = (assignmentData) => {
        return new Promise((resolve, reject) => {
            let payload = {
                ...assignmentData,
                allow_practice: assignmentData.quiz_type === 0, //all quizzes are practicable
            };

            ApiRequestService({
                method: 'post',
                url: '/addQuiz',
                data: payload
            }).then(res => {
                if (res && res.data && res.data.data) {
                    resolve({ success: true, data: res.data.data });
                } else {
                    resolve({ success: true, error: "Something went wrong" });
                }
            }).catch((err) => {
                reject({ success: false, error: err });
            });
        })
    }

    const handleLeftArrowClick = () => {
        let table = document.querySelector(".assignment-table");
        if (table) {
            table.scrollBy({
                left: -SCROLL_AMOUNT,
                behavior: "smooth",
            })
        }
    }

    const handleRightArrowClick = () => {
        let table = document.querySelector(".assignment-table");
        if (table) {
            table.scrollBy({
                left: SCROLL_AMOUNT,
                behavior: "smooth",
            })
        }
    }

    const getCourses = () => {
        ApiRequestService({
            method: 'post',
            url: '/getAllCourses'
        }).then(res => {
            if (res && res.data && res.data.data) {
                let newCourses = res.data.data.course_names;
                setCourses(newCourses);
                let firstCourse = newCourses[0];
                if (firstCourse) {
                    setSelectedCourse({
                        id: firstCourse.course_id,
                        label: firstCourse.course_name,
                    });
                    getAssignments({
                        course_id: firstCourse.course_id,
                    })
                }
            }
        })
    }

    const getSubjects = () => {
        ApiRequestService({
            method: 'post',
            url: '/getAllSubjects'
        }).then(res => {
            if (res && res.data && res.data.data) {
                let subjectsArr = res.data.data.subject_names.filter(subj => subj.sync_validation);
                setSubjects(subjectsArr);
            }
        })
    }

    const getTopics = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllTopics',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.data) {
                setTopics(res.data.data.topic_names);
            }
        })
    }

    const getCategories = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllCategories',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.data) {
                setCategories(res.data.data.category_names);
            }
        })
    }

    const getAssignments = async (payload) => {
        try {
            setLoading(true);
            const res = await ApiRequestService({
                method: 'post',
                url: '/getAllQuiz',
                data: payload
            });

            if (res?.data?.data?.quizes_list) {
                let quizArr = [];
                let quizIDArr = [];
                res.data.data.quizes_list.forEach(quiz => {
                    if (!quizIDArr.includes(quiz.quiz_id)) {
                        quizIDArr.push(quiz.quiz_id);
                        quizArr.push(quiz);
                    }
                })

                setAssignments(quizArr);

                let newPayload = {
                    course_id: payload.course_id,
                    quiz_id_arr: quizIDArr,
                }
                getAssignmentDetails(newPayload);
            } else {
                setLoading(false);
                setAssignments([]);
                setAssignmentDetails([]);
            }
        } catch (err) {
            setLoading(false);
            console.error("Error fetching quizzes:", err);
        }
    };


    const getAssignmentDetails = (payload) => {
        ApiRequestService({
            method: 'post',
            url: '/getQuizzesByIds',
            data: payload
        }).then(res => {
            if (res && res.data && res.data.data) {
                let arr = res.data.data;
                // arr.reverse();
                handleUpdateAssignmentDetails(arr);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const getSortedAssignments = (assignmentsArr) => {
        assignmentsArr.sort((assignA, assignB) => {
            const aValid = assignA.start_date && assignA.start_time && assignA.end_date && assignA.end_time;
            const bValid = assignB.start_date && assignB.start_time && assignB.end_date && assignB.end_time;

            if (!aValid && !bValid) return 0;
            if (!aValid) return 1;
            if (!bValid) return -1;

            const aMoment = moment(`${assignA.end_date} ${assignA.end_time}`, 'YYYY-MM-DD HH:mm:ss');
            const bMoment = moment(`${assignB.end_date} ${assignB.end_time}`, 'YYYY-MM-DD HH:mm:ss');

            return aMoment.diff(bMoment);
        });

        return assignmentsArr;
    };



    const handleCourseSelect = (_, value) => {
        if (value === null || value === undefined) return;
        setSelectedCourse(value);
        setAssignmentDetails([]);
        setMatrixCategories([]);
        getAssignments({
            course_id: value.id,
        })
    }

    const handleSubjectSelect = (_, value) => {
        setTopics(null);
        setCategories(null);
        setSelectedSubject(null);
        setSelectedTopic(null);
        setSelectedCategories(null);
        if (value == null) return;
        setSelectedSubject(value);
        getTopics({
            subject_id: value.id
        })
    }

    const handleTopicSelect = (_, value) => {
        setCategories(null);
        setSelectedTopic(null);
        setSelectedCategories(null);
        if (value == null) return;
        setSelectedTopic(value);
        getCategories({
            subject_id: value.data.subject_id,
            topic_id: value.data.topic_id
        })
    }

    const handleCategoriesSelect = (_, values) => {
        setSelectedCategories(null);
        if (values == null) return;
        let newSelectedCategories = [...values];
        setSelectedCategories(newSelectedCategories);
    }

    const handleAddCategories = () => {
        if (selectedCategories && selectedCategories.length) {

            let newMatrixCategories = [...matrixCategories];
            selectedCategories.forEach(selectedCat => {
                let matrixCat = {
                    ...selectedCat.data,
                    subject_name: selectedSubject?.data.subject_name,
                    topic_name: selectedTopic?.data.topic_name,
                };
                matrixCat.key = `${matrixCat.subject_id}_${matrixCat.topic_id}_${matrixCat.category_id}`
                matrixCat.columnDataArr = assignmentDetails.map(_ => null);
                newMatrixCategories.push(matrixCat);
            })
            setMatrixCategories(newMatrixCategories);
            setSelectedCategories([]);
        }
    }

    const handleDragStart = (index) => {
        setDraggedColIndex(index);
    };

    const handleDrop = (index) => {
        if (draggedColIndex === null || draggedColIndex === index) return;

        const newOrder = [...columnOrder];
        const fromIdx = newOrder.indexOf(draggedColIndex);
        const toIdx = newOrder.indexOf(index);

        newOrder.splice(fromIdx, 1);
        newOrder.splice(toIdx, 0, draggedColIndex);

        setColumnOrder(newOrder);
        setDraggedColIndex(null);
    };

    const handleAssignmentTagClick = (event, assignment) => {
        setAnchorEl(event.currentTarget);
        // setShowAssignmentDetailModal(true);
        setSelectedAssignment({
            ...assignment,
        });
    }

    const handleCategoryCellClick = (cat, columnDataIndex) => {
        let assignmentData = assignmentDetails[columnDataIndex]
        //console.debug("assignmentData>>?", assignmentData)
        if (assignmentData && cat.key) {
            setPickedAssignment(assignmentData);
            let obj = cat.columnDataArr[columnDataIndex];
            setPickedCategory({
                ...cat,
                key: `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`,
                ...obj,
                columnDataArr: null,
            });
            setShowCategoryModal(true);
        }
    }

    const handleViewFullDetailClick = () => {
        setShowAssignmentDetailModal(true);
    }

    const handleSearchCategories = (event) => {
        let str = event.target.value;
        setSearchText(str);
    }

    const handleAddAssignmentClick = () => {
        setShowNewAssignmentModal(true);
    }

    const onCompleteCreateAssignment = (newAssignment) => {
        let updatedAssignmentDetails = [...assignmentDetails];
        updatedAssignmentDetails.push(newAssignment);
        handleUpdateAssignmentDetails(updatedAssignmentDetails);
    }

    const onSaveCategoryModal = (updatedAssignment) => {
        let index = assignmentDetails.findIndex(assign => assign.quiz_id === updatedAssignment.quiz_id);
        if (index > -1) {
            let updatedAssignmentDetails = [...assignmentDetails];
            updatedAssignmentDetails[index] = updatedAssignment;
            handleUpdateAssignmentDetails(updatedAssignmentDetails);
            setShowCategoryModal(false);
        }
    }

    const onSaveAssignment = (updatedAssignment) => {
        let index = assignmentDetails.findIndex(assign => assign.quiz_id === updatedAssignment.quiz_id);
        if (index > -1) {
            let updatedAssignmentDetails = [...assignmentDetails];
            updatedAssignmentDetails[index] = updatedAssignment;
            handleUpdateAssignmentDetails(updatedAssignmentDetails);
        }
    }

    const onUpdateQuiz = (updatedData) => {
        let index = assignmentDetails.findIndex(assign => assign.quiz_id === updatedData.quiz_id);
        if (index > -1) {
            let updatedAssignmentDetails = [...assignmentDetails];
            updatedAssignmentDetails[index].quiz_name = updatedData.quiz_name;
            updatedAssignmentDetails[index].start_date = updatedData.start_date;
            updatedAssignmentDetails[index].start_time = updatedData.start_time;
            updatedAssignmentDetails[index].end_date = updatedData.end_date;
            updatedAssignmentDetails[index].end_time = updatedData.end_time;
            updatedAssignmentDetails[index].status = updatedData.status;
            handleUpdateAssignmentDetails(updatedAssignmentDetails);
        }
    }

    return (
        <SecureShow targetRole={1} >
            <div style={{
                padding: '0 2rem',
                marginTop: '-3.5rem',
            }}>


                <div style={{ width: '100%', margin: '1rem 0rem' }}>
                    <Grid container spacing={2} alignItems={'start'} flexWrap={'wrap'}>
                        <Grid item xs={4}>
                            <Autocomplete
                                disablePortal
                                style={{ width: "100%" }}
                                options={courses ? courses.map(course => {
                                    return {
                                        id: course.course_id,
                                        label: course.course_name,
                                        data: course,
                                    }
                                }) : []}
                                getOptionLabel={(option) => option.label}
                                sx={{ width: 300 }}
                                value={selectedCourse}
                                onChange={handleCourseSelect}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Courses"
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                                background: "#fff",
                                                borderRadius: "8px",
                                                '& input': {
                                                    color: '#bb0000',
                                                    fontWeight: 700,
                                                },
                                                /* '& .MuiOutlinedInput-notchedOutline': {
                                                    border: 'none',
                                                }, */
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Autocomplete
                                disablePortal
                                size='small'
                                options={subjects ? subjects.map(subject => {
                                    return {
                                        id: subject.subject_id,
                                        label: subject.subject_name,
                                        data: subject,
                                    }
                                }) : []}
                                value={selectedSubject}
                                onChange={handleSubjectSelect}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Subject"
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                                borderRadius: "6px",
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Autocomplete
                                disablePortal
                                size='small'
                                options={topics ? topics.map(topic => {
                                    return {
                                        id: topic.topic_id,
                                        label: topic.topic_name,
                                        data: topic,
                                    }
                                }) : []}
                                onChange={handleTopicSelect}
                                value={selectedTopic}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Topic"
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                                borderRadius: "6px",
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Autocomplete
                                disablePortal
                                size='small'
                                options={mappedCategories}
                                multiple
                                filterSelectedOptions
                                value={selectedCategories ? selectedCategories : []}
                                onChange={handleCategoriesSelect}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Categories"
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                                borderRadius: "6px",
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Tooltip
                                arrow
                                disableHoverListener={selectedCategories && selectedCategories.length > 0}
                                title={
                                    <Typography className="text-white" fontSize={14}>
                                        Please select one or more categories to add to the matrix.
                                    </Typography>
                                }
                            >
                                <span>
                                    <Button
                                        variant="contained"
                                        onClick={handleAddCategories}
                                        disabled={!selectedCategories || selectedCategories.length === 0}
                                    >
                                        {`Add Categor${selectedCategories && selectedCategories.length > 1 ? 'ies' : 'y'} To Matrix`}
                                    </Button>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>

                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', gap: "1rem", margin: "1.2rem 0rem", }}>
                    <div style={{ display: "flex", gap: "12px", alignItems: 'center' }}>
                        <div style={{ fontWeight: 'bold', color: '#000', fontSize: '16px', }}>
                            Assignment Matrix:
                            {/* ({matrixCategories?.length}, {assignments?.length}) */}
                        </div>
                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-start", gap: "12px" }} className='legend-box'>
                            <SFTooltip text="Assignment visible and accessible to students">
                                <div className='single-legend'>
                                    <IoCheckmarkCircle color='#80C75B' fontSize={20} />
                                    <div> - Published</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text="Assignment not visible or accessible to students">
                                <div className='single-legend'>
                                    <RiProhibited2Line color='#5D5D5D' fontSize={20} />
                                    <div> - Unpublished</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text="Assignment setup is incomplete. Please complete it to publish.">
                                <div className='single-legend'>
                                    <FaExclamation color='red' fontSize={20} />
                                    <div> - Incomplete Assignment</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text={<div>Assignment in mastery mode in which student must correctly answer N = Mastery Count questions in a row to get credit for the skill category. <br /> For partially completed categories, partial credit is allowed only if the “Allow Partial Credit” is selected in the assignment settings.</div>}>
                                <div className='single-legend'>
                                    <FaSquareFull color='#bb0000' fontSize={16} />
                                    <div> - Mastery</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text="Required number of correctly-answered questions in a row to get full credit for the assigned skill category.">
                                <div className='single-legend'>
                                    <FaHashtag color='#bb0000' fontSize={16} />
                                    <div> - Mastery Count</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text="Assignment in test mode in which students answer questions, like in a test or quiz.">
                                <div className='single-legend'>
                                    <FaSquareFull color='#0004FF' fontSize={16} />
                                    <div> - Test</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text="Number of questions">
                                <div className='single-legend'>
                                    <FaHashtag color='#0004FF' fontSize={16} />
                                    <div> - No. of questions</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text="The category in the assignment is viewed first by the student and shown until mastery is achieved.">
                                <div className='single-legend'>
                                    <div class="triangle" style={{ borderLeftColor: "#34C759" }}></div>
                                    <div> - At First</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text="The category is viewed last by the student, after mastery is achieved by all other categories in the assignment.">
                                <div className='single-legend'>
                                    <div class="triangle" style={{ borderLeftColor: "#FF3B30" }}></div>
                                    <div> - At Last</div>
                                </div>
                            </SFTooltip>
                            <SFTooltip text="The category is not strictly required: it is in a list of N categories from which students must choose and master at least n<N categories to achieve full credit for the assignment.">
                                <div className='single-legend'>
                                    <div class="triangle" style={{ borderLeftColor: "#FF9500" }}></div>
                                    <div> - Free Choice</div>
                                </div>
                            </SFTooltip>
                        </div>
                    </div>
                    <div>
                        <Button variant='contained' onClick={() => setShowImportModal(true)}>
                            Import Assignments
                        </Button>
                    </div>
                </div>

                <div>
                    {rightClickedCategory && action ? <span className='ml-2 text-secondary' style={{
                        fontWeight: 'normal',
                        fontSize: '14',
                    }}> (Press ESCAPE to cancel the action)</span> : null}
                </div>

                {/* Table Start */}
                <div className='table-parent'>
                    {showArrow ?
                        <React.Fragment>
                            <div className='matrix-arrow left-arrow'>
                                <IconButton onClick={handleLeftArrowClick}>
                                    <FaArrowLeft fontSize={16} color='#fff' />
                                </IconButton>
                            </div>
                            <div className='matrix-arrow right-arrow'>
                                <IconButton onClick={handleRightArrowClick}>
                                    <FaArrowRight fontSize={16} color='#fff' />
                                </IconButton>
                            </div>
                        </React.Fragment> : null}
                    <div className='matrix-table-container assignment-table'>
                        {loading ? (
                            <div className='matrix-loader'>
                                <BeatLoader color={'#bb0000'} loading={true} size={15} />
                            </div>
                        ) : null}

                        <table className="matrix-table">
                            <thead className='matrix-table-head'>
                                <tr className='cat-assign-header'>
                                    {/* <th colSpan={3}></th> */}
                                    <th colSpan={2}>
                                        <div className='category-header'>
                                            <div>Categories</div>
                                            <small>({matrixCategories?.length})</small>
                                        </div>
                                    </th>
                                    <th colSpan={assignmentDetails?.length + 10 ?? 0}>
                                        <div className='assignment-header'>
                                            <div>Assignments
                                                <small>({assignments?.length})</small>
                                            </div>
                                            <div>
                                                <Tooltip
                                                    title={<Typography className='text-white' fontSize={14}>
                                                        Assignments are arranged by due date
                                                    </Typography>}
                                                    placement='top'
                                                    arrow
                                                >
                                                    <span>
                                                        <BsInfoCircleFill color='#737373' size={14}
                                                            style={{
                                                                flexShrink: 0,
                                                                minWidth: "12px",
                                                                minHeight: "12px",
                                                                verticalAlign: "middle",
                                                                cursor: "pointer",
                                                            }} />
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                                <tr className="matrix-row-header">
                                    <th className="matrix-row-cell">
                                        <div className='no-cell-top-border'></div>
                                        <div style={{ width: "100%" }}>
                                            No.
                                        </div>
                                    </th>
                                    {/*  <th className="matrix-row-cell">
                                        Subject Name
                                    </th>
                                    <th className="matrix-row-cell">
                                        Topic Name
                                    </th> */}
                                    <th className="matrix-row-cell" style={{
                                        minWidth: '400px'
                                    }} >
                                        <div className='category-cell-top-border'></div>
                                        <div style={{ width: '100%', }}>
                                            <TextField
                                                size='small'
                                                className='search-category-field'
                                                placeholder='Search Categories'
                                                value={searchText}
                                                onChange={handleSearchCategories}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <IoIosSearch fontSize={24} />
                                                        </InputAdornment>
                                                    )
                                                }}
                                                sx={{
                                                    width: '90%',
                                                    borderRadius: '8px',
                                                    '& .MuiInputBase-root': {
                                                        height: '34px',
                                                    }
                                                }}
                                            />
                                        </div>
                                    </th>
                                    {assignmentDetails?.map((assign, assignIndex) => {
                                        let isDateFilled = true;
                                        if (assign.start_date === "" || assign.start_date === null || assign.end_date === "" || assign.end_date === null) {
                                            isDateFilled = false;
                                        }
                                        return (
                                            <th
                                                key={assignIndex}
                                                className="matrix-row-cell"
                                                style={{ color: assignIndex === 0 ? '#bb0000' : 'black' }}
                                            >
                                                <div
                                                    className="assign-header-tag cat-cell"
                                                    onClick={(event) => {
                                                        // let assignDetail = assignmentDetails[assignIndex];
                                                        handleAssignmentTagClick(event, assign);
                                                    }}
                                                    aria-describedby={assignIndex}
                                                    style={{ color: assign.quiz_type === 0 ? '#bb0000' : "#0004FF" }}
                                                >
                                                    <div className='assign-cell-top-border'></div>
                                                    <div className="cat-cell-border"></div>
                                                    {assignIndex + 1}
                                                    <div className='status-icon'>
                                                        {isDateFilled ? (assign.status === 1 ?
                                                            <IoCheckmarkCircle color='#80C75B' />
                                                            : <MdBlock color='#5d5d5d' />) :
                                                            <FaExclamation color='red' />
                                                        }
                                                    </div>

                                                </div>
                                            </th>
                                        )
                                    })}

                                    <th className="matrix-row-cell add-cell-container">
                                        <div className='add-cell-btn' onClick={handleAddAssignmentClick}>
                                            + ADD
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {matrixCategories && matrixCategories.filter(cat => cat.category_name.toLowerCase().includes(searchText.toLowerCase())).map((cat, index) => {
                                    // //console.debug("sourceCategory>>??", sourceCategory)
                                    let disabled = false;
                                    if (sourceCategory && sourceCategory.key !== cat.key) {
                                        disabled = true;
                                    }
                                    return (
                                        <tr className="matrix-row" key={index}>
                                            <td className="matrix-row-cell" style={{
                                                backgroundColor: disabled ? '#e6e6e6' : '#fafafa',
                                                filter: disabled ? 'grayscale(1.0)' : 'grayscale(0)',
                                            }}>{index + 1}</td>

                                            {/* <td className='matrix-row-cell text-align-left px-2' style={{minWidth:"200px"}}>
                                                {cat.subject_name}
                                            </td>
                                            <td className='matrix-row-cell text-align-left px-2' style={{minWidth:"200px"}}>
                                                {cat.topic_name}
                                            </td> */}

                                            <td className="matrix-row-cell category-width" style={{
                                                textAlign: 'left',
                                                backgroundColor: disabled ? '#e6e6e6' : '#fafafa',
                                                filter: disabled ? 'grayscale(1.0)' : 'grayscale(0)',
                                            }}>
                                                <div className='category-name-cell'>
                                                    <div className='stackable-icon-container'>
                                                        <Tooltip
                                                            title={<Typography className='text-white' fontSize={14}>
                                                                <div>Subject: {cat.subject_name}</div>
                                                                <div>Topic: {cat.topic_name}</div>
                                                            </Typography>}
                                                            arrow placement="top">
                                                            <div className='stackable-icon stackable-subject-icon'>
                                                                ST
                                                            </div>
                                                        </Tooltip>
                                                        {/* <Tooltip
                                                            title={<Typography className='text-white' fontSize={14}>
                                                                {cat.topic_name}</Typography>}
                                                            arrow placement="top">
                                                            <div className='stackable-icon stackable-topic-icon'>
                                                                T
                                                            </div>
                                                        </Tooltip> */}
                                                    </div>
                                                    <div className='category-name'>
                                                        {cat.category_name}
                                                    </div>
                                                </div>
                                            </td>

                                            {cat.columnDataArr && cat.columnDataArr.length ?
                                                cat.columnDataArr.map((columnData, columnDataIndex) => {

                                                    let backgroundColor = '';

                                                    let color = "transparent";
                                                    if (columnData) {
                                                        //console.debug("columnData>>??", columnData)
                                                        if (columnData.atFirst) {
                                                            color = "#34c759";
                                                        } else if (columnData.atLast) {
                                                            color = "#ff3b30"
                                                        } else if (columnData.freeChoice) {
                                                            color = "#ff9500"
                                                        }
                                                    }

                                                    let bgColor = '';
                                                    let borderColor = '';
                                                    let borderStyle = 'solid';
                                                    let disabled = false;
                                                    let isSrcCategory = false;

                                                    if (columnData) {
                                                        if (columnData.isTest && columnData.noOfQuestions > 0) {
                                                            backgroundColor = 'rgba(0, 4, 255, 0.05)'
                                                        } else if (!columnData.isTest && columnData.masteryCount > 0) {
                                                            backgroundColor = 'rgba(187, 0, 0, 0.05)'
                                                        }
                                                    }

                                                    if (targetCategory) {
                                                        if (targetCategory.quiz_type === columnData.quiz_type && targetCategory.key === cat.key && targetCategory.columnDataIndex === columnDataIndex) {
                                                            borderColor = '#0D99FF';
                                                        }
                                                    }
                                                    if (rightClickedCategory) {

                                                        if (rightClickedCategory.quiz_type === columnData.quiz_type && rightClickedCategory.key === cat.key && rightClickedCategory.columnDataIndex !== columnDataIndex) {
                                                            // if (action === 'cut' || action === 'copy') {
                                                            //     bgColor = '#80C75B';
                                                            // }
                                                        } else {
                                                            if (action === 'cut' || action === 'copy') {
                                                                bgColor = '#f6f6f6';
                                                                // bgColor = '#e1e6ed';
                                                                disabled = true;
                                                            }
                                                        }

                                                        if (rightClickedCategory.quiz_type === columnData.quiz_type && rightClickedCategory.key === cat.key && rightClickedCategory.columnDataIndex === columnDataIndex) {
                                                            borderColor = '#0D99FF';
                                                            if (action === 'cut') {
                                                                borderStyle = 'dashed';
                                                            }
                                                            isSrcCategory = true;
                                                            disabled = false;
                                                        }
                                                    }

                                                    return (
                                                        <td key={columnDataIndex} className="matrix-row-cell">
                                                            <div className={`cat-cell  ${columnData !== null ? "cat-cell-content" : ""}
                                                                ${disabled ? 'cat-cell-disabled' : ''}
                                                            `}
                                                                style={{
                                                                    color: columnData?.isTest ? "#0004FF" : "#bb0000",
                                                                    backgroundColor: bgColor,
                                                                }}
                                                                onClick={() => {
                                                                    if (!disabled) {
                                                                        handleCategoryCellClick(cat, columnDataIndex)
                                                                    }
                                                                }}
                                                                onContextMenu={e => {
                                                                    e.preventDefault();
                                                                    if (action === null && columnData.masteryCount === undefined) {
                                                                        return
                                                                    }
                                                                    // if (!disabled && !isSrcCategory && columnData.masteryCount) {
                                                                    if (!disabled && !isSrcCategory) {
                                                                        //console.debug("columnData>>??", columnData)
                                                                        if (action === null) {
                                                                            setRightClickedCategory({
                                                                                ...cat,
                                                                                ...columnData,
                                                                                columnDataIndex,
                                                                            });
                                                                        } else {
                                                                            setTargetCategory({
                                                                                ...cat,
                                                                                ...columnData,
                                                                                columnDataIndex,
                                                                            })
                                                                        }
                                                                        setContextMenuAnchorEl(e.currentTarget);
                                                                    }
                                                                }}
                                                            >
                                                                <div className={`cat-cell-border ${borderColor ? "cat-cell-border-animation" : ""}
                                                                `}
                                                                    style={{
                                                                        backgroundColor: backgroundColor,
                                                                        borderColor: borderColor,
                                                                        borderStyle: borderStyle,
                                                                    }}></div>

                                                                <div className='cat-cell-triangle' style={{
                                                                    borderLeftColor: color,
                                                                }}></div>
                                                                {columnData?.isTest ?
                                                                    columnData?.noOfQuestions
                                                                    :
                                                                    columnData?.masteryCount
                                                                }
                                                            </div>
                                                        </td>
                                                    )
                                                })
                                                : null}
                                            {/* <td className='matrix-row-cell'></td>
                                            <td className='matrix-row-cell'></td>
                                            <td className='matrix-row-cell'></td>
                                            <td className='matrix-row-cell'></td>
                                            <td className='matrix-row-cell'></td> */}
                                            <td className="matrix-row-cell add-cell"></td>
                                        </tr>

                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>


                {/* Legend */}
                {/* <h4 style={{ fontWeight: 'bolder', marginTop: "2rem" }}>
                    Legends:
                </h4> */}
                <div className='legend-container' style={{ marginTop: "2rem", marginBottom: '4rem' }}>
                    <div className='legend-col'>
                        <SFTooltip text="Assignment visible and accessible to students">
                            <div className='single-legend'>
                                <IoCheckmarkCircle color='#80C75B' fontSize={20} />
                                <div> - Published</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Assignment not visible or accessible to students">
                            <div className='single-legend'>
                                <RiProhibited2Line color='#5D5D5D' fontSize={20} />
                                <div> - Unpublished</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Assignment setup is incomplete. Please complete it to publish.">
                            <div className='single-legend'>
                                <FaExclamation color='red' fontSize={20} />
                                <div> - Incomplete Assignment</div>
                            </div>
                        </SFTooltip>
                    </div>
                    <div className='legend-col'>
                        <SFTooltip text={<div>Assignment in mastery mode in which student must correctly answer N = Mastery Count questions in a row to get credit for the skill category. <br /> For partially completed categories, partial credit is allowed only if the “Allow Partial Credit” is selected in the assignment settings.</div>}>
                            <div className='single-legend'>
                                <FaSquareFull color='#bb0000' fontSize={16} />
                                <div> - Mastery</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Required number of correctly-answered questions in a row to get full credit for the assigned skill category.">
                            <div className='single-legend'>
                                <FaHashtag color='#bb0000' fontSize={16} />
                                <div> - Mastery Count</div>
                            </div>
                        </SFTooltip>
                    </div>
                    <div className='legend-col'>
                        <SFTooltip text="Assignment in test mode in which students answer questions, like in a test or quiz.">
                            <div className='single-legend'>
                                <FaSquareFull color='#0004FF' fontSize={16} />
                                <div> - Test</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="Number of questions">
                            <div className='single-legend'>
                                <FaHashtag color='#0004FF' fontSize={16} />
                                <div> - No. of questions</div>
                            </div>
                        </SFTooltip>
                    </div>
                    <div className='legend-col'>
                        <SFTooltip text="The category in the assignment is viewed first by the student and shown until mastery is achieved.">
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#34C759" }}></div>
                                <div> - At First</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="The category is viewed last by the student, after mastery is achieved by all other categories in the assignment.">
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#FF3B30" }}></div>
                                <div> - At Last</div>
                            </div>
                        </SFTooltip>
                        <SFTooltip text="The category is not strictly required: it is in a list of N categories from which students must choose and master at least n<N categories to achieve full credit for the assignment.">
                            <div className='single-legend'>
                                <div class="triangle" style={{ borderLeftColor: "#FF9500" }}></div>
                                <div> - Free Choice</div>
                            </div>
                        </SFTooltip>
                    </div>
                </div>
            </div>

            {/* Assignment Popup */}
            {anchorEl ?
                <AssignmentPopover
                    anchorEl={anchorEl}
                    handleClose={() => setAnchorEl(null)}
                    assignment={selectedAssignment}
                    handleViewFullDetailClick={handleViewFullDetailClick}
                    onUpdateQuiz={onUpdateQuiz}
                    checkIfAssignmentIsValid={checkIfAssignmentIsValid}
                />
                : null}

            {/* Add New Assignment  */}
            {showNewAssignmentModal ?
                <NewAssignmentModal
                    showModal={showNewAssignmentModal}
                    handleClose={() => setShowNewAssignmentModal(false)}
                    course_id={selectedCourse?.id}
                    onCompleteCreateAssignment={onCompleteCreateAssignment}
                />
                : null}

            {/* Category Modal */}
            {showCategoryModal ?
                <CategoryModal
                    showModal={showCategoryModal}
                    handleClose={() => setShowCategoryModal(false)}
                    pickedAssignment={pickedAssignment}
                    pickedCategoryKey={pickedCategory.key}
                    pickedCategory={pickedCategory}
                    onSaveCategoryModal={onSaveCategoryModal}
                />
                : null}

            {/*Import assignments  */}
            <CopyAllQuizDialog
                visible={showImportModal}
                onHide={() => setShowImportModal(false)}
                onCompleteCopyQuiz={onCompleteCopyQuiz}
                courseID={selectedCourse?.id}
                fromMatrixPage={true}
            />

            {showAssignmentDetailModal ?
                <AssignmentDetailModal
                    showModal={showAssignmentDetailModal}
                    assignment={selectedAssignment}
                    handleClose={() => {
                        setAnchorEl(null);
                        setShowAssignmentDetailModal(false);
                    }}
                    onSaveAssignment={onSaveAssignment}
                    course_id={selectedCourse?.id}
                />
                : null}

            <ContextMenu
                anchorEl={contextMenuAnchorEl}
                handleClose={() => {
                    if (action === null) {
                        setRightClickedCategory(null);
                        setSourceCategory(null);
                    } else {
                        setTargetCategory(null);
                    }

                    setContextMenuAnchorEl(null);
                }}
                action={action}
                handleActionClick={handleActionClick}
            />

        </SecureShow>
    );
}


class AssignmentPopover extends Component {

    debounceTimer = null;

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            startDate: "",
            endDate: "",
            subCategories: [],
            status: 0,
            loading: false,
        }
    }


    componentDidMount() {
        if (this.props.assignment) {
            var startDateAndTime = this.props.assignment.start_date + ' ' + this.props.assignment.start_time;
            var endDateAndTime = this.props.assignment.end_date + ' ' + this.props.assignment.end_time;
            var resStartDate = '';
            var resEndDate = '';
            if (
                this.props.assignment.start_date !== null &&
                this.props.assignment.start_date !== ''
            ) {
                resStartDate = moment(startDateAndTime, 'DD-MM-YYYY HH-mm');
            }
            if (
                this.props.assignment.end_date !== null &&
                this.props.assignment.end_date !== ''
            ) {
                resEndDate = moment(endDateAndTime, 'DD-MM-YYYY HH-mm');
            }

            this.setState({
                name: this.props.assignment.quiz_name,
                startDate: resStartDate,
                endDate: resEndDate,
                subCategories: this.props.assignment.quiz_subcat_info,
                status: this.props.assignment.status,
            })
        }
    }

    componentWillUnmount() {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }

    isValidDate = function (d) {
        return d instanceof Date && !isNaN(d);
    }

    handleChangeStartDate = (timeString, sDate, event) => {
        if (sDate !== null) {
            this.setState({
                startDate: moment(sDate),
            }, () => this.onStartDateChange())
        }
    }

    handleChangeEndDate = (eDate, id) => {
        if (eDate !== null) {
            let date = moment(eDate)
            if (id === "date") {
                date.set({ "h": 23, "m": 59 })
            }
            this.setState({
                endDate: date,
            }, () => this.onEndDateChange())
        }
    }

    handleNameChange = (e) => {
        const value = e.target.value;
        this.setState({ name: value });

        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            this.updateQuiz();
        }, 500);
    };

    onStartDateChange = () => {
        this.setState({ loading: true });
        let tempstartDate = this.state.startDate;
        if (tempstartDate === "") {
            NotificationManager.error("Start date should not be empty");
            return;
        }
        let startDate = tempstartDate.format('DD/MM/YYYY');
        tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
        let startTime = tempstartDate[1];

        let payload = {
            quiz_id: this.props.assignment.quiz_id,
            quiz_name: this.state.name,
            start_date: startDate,
            start_time: startTime,
            end_date: this.props.assignment.end_date,
            end_time: this.props.assignment.end_time,
            status: this.state.status,
        }
        ApiRequestService({
            method: 'post',
            url: '/updateQuiz',
            data: payload,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.data) {
                if (res.data.message === "") {
                    NotificationManager.success("Updated Successfully");
                    this.props.onUpdateQuiz(payload);
                } else {
                    NotificationManager.error("Something went wrong");
                }
            }
        })
    }

    onEndDateChange = () => {
        this.setState({ loading: true });
        let tempendDate = this.state.endDate;
        if (tempendDate === "") {
            NotificationManager.error("End date should not be empty");
            return;
        }
        let endDate = tempendDate.format('DD/MM/YYYY');
        tempendDate = tempendDate.format('DD/MM/YYYY HH:mm').split(' ');
        let endTime = tempendDate[1];

        let payload = {
            quiz_id: this.props.assignment.quiz_id,
            quiz_name: this.state.name,
            start_date: this.props.assignment.start_date,
            start_time: this.props.assignment.start_time,
            end_date: endDate,
            end_time: endTime,
            status: this.state.status,
        }
        ApiRequestService({
            method: 'post',
            url: '/updateQuiz',
            data: payload,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.data) {
                if (res.data.message === "") {
                    NotificationManager.success("Updated Successfully");
                    this.props.onUpdateQuiz(payload);
                } else {
                    NotificationManager.error("Something went wrong");
                }
            }
        })
    }

    updateQuiz = () => {
        this.setState({ loading: true });
        let tempstartDate = this.state.startDate;
        let tempendDate = this.state.endDate;

        if (tempstartDate === "") {
            NotificationManager.error("Start date should not be empty");
            return;
        }
        if (tempendDate === "") {
            NotificationManager.error("End date should not be empty");
            return;
        }

        let startDate = tempstartDate.format('DD/MM/YYYY');
        tempstartDate = tempstartDate.format('DD/MM/YYYY HH:mm').split(' ');
        let startTime = tempstartDate[1];

        let endDate = tempendDate.format('DD/MM/YYYY');
        tempendDate = tempendDate.format('DD/MM/YYYY HH:mm').split(' ');
        let endTime = tempendDate[1];

        let payload = {
            quiz_id: this.props.assignment.quiz_id,
            quiz_name: this.state.name,
            start_date: startDate,
            start_time: startTime,
            end_date: endDate,
            end_time: endTime,
            status: this.state.status,
        }
        //console.debug("payload>>??", payload)
        ApiRequestService({
            method: 'post',
            url: '/updateQuiz',
            data: payload,
        }).then(res => {
            this.setState({ loading: false });
            if (res && res.data) {
                if (res.data.message === "") {
                    NotificationManager.success("Updated Successfully");
                    this.props.onUpdateQuiz(payload);
                } else {
                    NotificationManager.error("Something went wrong");
                }
            }
        })
    }

    render() {

        let startDateLocal = moment(this.state.startDate).toDate();
        let endDateLocal = moment(this.state.endDate).toDate();

        return (
            <Popover
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                anchorEl={this.props.anchorEl}
                open={Boolean(this.props.anchorEl)}
                id={1}
                style={{
                    top: "-6px"
                }}
                onClose={this.props.handleClose}
                PaperProps={{
                    sx: {
                        width: '400px',
                        height: '175px',
                        borderRadius: '8px',
                        overflow: 'visible',
                        // mb: 5,
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: '50%',
                            transform: 'translate(-50%, 50%) rotate(45deg)',
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            zIndex: 0,
                        },
                    },
                }}
            >
                <div style={{ padding: "1rem" }} className='assignment-popover'>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextField placeholder='Assignment name' size='small'
                                value={this.state.name}
                                onChange={this.handleNameChange}
                                sx={{
                                    width: "100%",
                                    '& .MuiInputBase-root': {
                                        height: '30px',
                                        borderRadius: '4px'
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <div style={{ fontWeight: '500', fontSize: '14px' }}>Start Date:</div>
                            <DatePicker
                                displayMode="portrait"
                                value={this.isValidDate(startDateLocal) ? startDateLocal : null}
                                onChange={this.handleChangeStartDate}
                                className='popup-picker'
                                placeholder='Start Date'
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <div style={{ fontWeight: '500', fontSize: '14px' }}>Start Time:</div>
                            <TimePicker
                                displayMode="portrait"
                                value={this.isValidDate(startDateLocal) ? startDateLocal : null}
                                onChange={this.handleChangeStartDate}
                                className='popup-picker' placeholder='Start Time' />
                        </Grid>
                        <Grid item xs={3}>
                            <div style={{ fontWeight: '500', fontSize: '14px' }}>End Date:</div>
                            <DatePicker
                                displayMode="portrait"
                                value={this.isValidDate(endDateLocal) ? endDateLocal : null}
                                onChange={(_, date) => this.handleChangeEndDate(date, "date")}
                                className='popup-picker' placeholder='End Date' />
                        </Grid>
                        <Grid item xs={3}>
                            <div style={{ fontWeight: '500', fontSize: '14px' }}>End Time:</div>
                            <TimePicker
                                displayMode="portrait"
                                value={this.isValidDate(endDateLocal) ? endDateLocal : null}
                                onChange={(_, date) => this.handleChangeEndDate(date, "date")}
                                className='popup-picker' placeholder='End Time' />
                        </Grid>
                        <Grid item xs={6}>
                            <div className='cursor-pointer'
                                style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", width: 'fit-content' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    let val = this.state.status === 0 ? 1 : 0;

                                    let updatedAssignment = {
                                        ...this.props.assignment,
                                        quiz_name: this.state.name,
                                    }

                                    let isValid = this.props.checkIfAssignmentIsValid(updatedAssignment);
                                    if (isValid) {
                                        this.setState({ status: val }, () => this.updateQuiz());
                                    }

                                    // check if assignment is valid
                                    //console.debug("this.state>>??", this.state)
                                    /* if (this.state.name === "") {
                                        NotificationManager.error("Assignment name cannot be empty before publishing");
                                        return;
                                    }
                                    if (this.state.startDate === "" || this.state.endDate === "") {
                                        NotificationManager.error("Dates cannot be empty before publishing");
                                        return;
                                    }
                                    if (this.state.subCategories === null || this.state.subCategories === undefined || this.state.subCategories.length == 0) {
                                        NotificationManager.error("Please add atleast one category before publishing");
                                        return;
                                    }
                                    this.setState({ status: val }, () => this.updateQuiz()) */
                                }}>
                                <Toggle
                                    checked={this.state.status === 1}
                                    icons={false}
                                    onClick={e => e.stopPropagation()}
                                    onChange={(e) => e.stopPropagation()}
                                    className='custom-react-toggle'

                                />
                                <div>Publish</div>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div className='small-table-container'>
                                <table className='small-table' style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "50%", textAlign: "left" }}>Categories</th>
                                            <th style={{ width: "50%", textAlign: "left" }}>Subcategories</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.subCategories?.map((subCat, index) => (
                                            <tr key={index}>
                                                <td>{subCat.category_Name}</td>
                                                <td>{subCat.subcategory_name}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Grid>
                        <div className='popover-footer' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div className='text-btn' onClick={this.props.handleViewFullDetailClick} style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "4px"
                            }}>
                                <FiFile />
                                <div>
                                    View Raw Data
                                </div>
                            </div>
                            <div className='text-btn' onClick={this.props.handleViewFullDetailClick} style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "4px"
                            }}>
                                <FiEdit />
                                <div>
                                    View Full Detail
                                </div>
                            </div>
                        </div>

                    </Grid>
                </div>
            </Popover>
        )
    }
}


const ContextMenu = ({ action, anchorEl, handleClose, handleActionClick }) => {

    const open = Boolean(anchorEl);

    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    minWidth: '100px',
                },
            }}
        >
            {/* <MenuItem className='menu-item' onClick={() => handleActionClick("cut")} disabled={action !== null}>
                <div className='context-list'>
                    <MdOutlineContentCut />
                    <div>Cut</div>
                </div>
            </MenuItem> */}
            <MenuItem className='menu-item' onClick={() => handleActionClick("copy")} disabled={action !== null}>
                <div className='context-list'>
                    <MdOutlineContentCopy />
                    <div>Copy</div>
                </div>
            </MenuItem>
            <MenuItem className='menu-item' onClick={() => handleActionClick("paste")} disabled={action === null}>
                <div className='context-list'>
                    <MdOutlineContentPaste />
                    <div>Paste</div>
                </div>
            </MenuItem>
        </Menu>
    )
}

const SFTooltip = (props) => {
    return (
        <Tooltip
            title={<Typography className='text-white' fontSize={14}>
                {props.text}</Typography>}
            arrow placement="top">
            {props.children}
        </Tooltip>
    )
}

export default AssignmentMatrix;

